<template>
    <region-choice-section
        class="region-choice-section-module"
        :title="attributes.regionChoice_title"
        :intro="attributes.regionChoice_intro"
        :regions="mappedRegions"
    />
</template>

<script>
    import RegionChoiceSection from '../../../organisms/RegionChoiceSection/RegionChoiceSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'region-choice-section-module',

        components: { RegionChoiceSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Map api region data into region format.
             *
             * @returns {Array}
             */
            mappedRegions() {
                return (this.attributes.region || []).map((region) => {
                    let link = region.page.uri;

                    const locale = region.locale.code;

                    if (locale !== 'en') {
                        link = `/${ locale }${ link }`;
                    }

                    return {
                        name: region.name,
                        icon: formatMediaObject.call(this, region.icon),
                        link,
                    };
                });
            },
        },
    };
</script>
